import { render, staticRenderFns } from "./MessageNPS.vue?vue&type=template&id=34f3f536"
import script from "./MessageNPS.vue?vue&type=script&lang=js"
export * from "./MessageNPS.vue?vue&type=script&lang=js"
import style0 from "./MessageNPS.vue?vue&type=style&index=0&id=34f3f536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports